var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.calendarFilters = {
	boxes: undefined,
	categoryVal: 'all',
	monthVal: 'all',

	init: function() {
		var $body = $('body');
		if (!$body.is('.calendar')) return;

		var $calendar = $('#calendar');
		var $filters = $calendar.find('.calendar__filters');
		var $categoryFilter;
		var $monthFilter;

		if ($filters.length > 0) {
			$categoryFilter = $filters.find('#categoryFilter');
			$app = $categoryFilter.find('option[value="app"]');
			if ($app) {
				$app.hide();
			}
			$monthFilter = $filters.find('#monthFilter');
			site.calendarFilters.boxes = $calendar.find('.boxes .event');
		}
		else {
			var $box = $('#below');
			$filters = $box.find('.calendar__filters');
			$categoryFilter = $filters.find('#categoryFilter');
			$monthFilter = $filters.find('#monthFilter');
			site.calendarFilters.boxes = $box.find('.boxes .event');
		}

		$categoryFilter.on('change', site.calendarFilters.handleCategoryChange);
		$monthFilter.on('change', site.calendarFilters.handleMonthChange);
	},

	handleCategoryChange: function() {
		site.calendarFilters.categoryVal = $(this).val();
		site.calendarFilters.updateVisibility();
	},

	handleMonthChange: function() {
		site.calendarFilters.monthVal = $(this).val();
		site.calendarFilters.updateVisibility();
	},

	updateVisibility: function() {
		var $catVal = site.calendarFilters.categoryVal;
		var $monthVal = site.calendarFilters.monthVal;
		site.calendarFilters.boxes.hide();

		site.calendarFilters.boxes.filter(function() {
				if ($catVal === 'all' && $monthVal === 'all') {
					return true;
				}
				if ($catVal === 'all') {
					return $(this).is('.' + site.calendarFilters.monthVal);
				} else if ($monthVal === 'all') {
					return $(this).is('.' + site.calendarFilters.categoryVal);
				} else {
					return $(this).is('.' + site.calendarFilters.categoryVal) && $(this).is('.' + site.calendarFilters.monthVal);
				}
			}
		).show();
	}
};

site.calendarCarousel = {
	init: function() {
		var $body = $('body');
		if ($body.is('.frontpage')) {
			site.owl.init('.menu.eventList', {
				items: 6,
				margin: 30,
				dots: false,
				nav: true,
				navText: '',
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 3,
						slideBy: 3
					},
					993: {
						items: 4,
						slideBy: 4
					},
					1350: {
						items: 5,
						slideBy: 5
					},
					1500: {
						items: 6,
						slideBy: 6
					}

				}
			});
		} else {
			site.owl.init('.menu.eventList', {
				items: 4,
				margin: 30,
				dots: false,
				nav: true,
				navText: '',
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 3,
						slideBy: 3
					},
					992: {
						items: 4,
						slideBy: 4
					}
				}
			});
		}

	}
};

site.socialCarousel = {
	init: function() {
		var $body = $('body');
		if ($body.is('.frontpage')) {
			site.owl.init('#instagram .grams', {
				items: 6,
				margin: 10,
				dots: false,
				nav: true,
				navText: '',
				responsive: {
					0: {
						items: 2
					},
					768: {
						items: 3,
						slideBy: 3
					},
					993: {
						items: 4,
						slideBy: 4
					},
					1350: {
						items: 4,
						slideBy: 4
					},
					1500: {
						items: 4,
						slideBy: 4
					}

				}
			});
		} else {
			site.owl.init('#instagram .grams', {
				items: 4,
				margin: 10,
				dots: false,
				nav: true,
				navText: '',
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 3,
						slideBy: 3
					},
					992: {
						items: 4,
						slideBy: 4
					}
				}
			});
		}

	}
};


site.frontpage = {
	init: function() {
		site.owl.init('#banner > ul', {
			items: 1,
			loop: true,
			dots: true,
			autoplay: true,
			smartSpeed: 700,
			autoplayTimeout:5000,
			autoplayHoverPause:true,
		});
	}
};

site.subpagebanner = {
	init: function() {
		site.owl.init('#subpage-banner > ul', {
			items: 1,
			loop: false,
			dots: true,
			autoplay: true,
			smartSpeed: 700,
			autoplayTimeout:5000,
			autoplayHoverPause:true,
		});
	},
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.calendarFilters.init();
	site.calendarCarousel.init();
	site.socialCarousel.init();

	var $msnryGrid = $('.filterControls + .items');
	if ($msnryGrid.length) {
		$msnryGrid.imagesLoaded(function () {
			$msnryGrid.masonry({
				columnWidth: 1,
				itemSelector: '.item'
			});

			$('.filterControls').on('click touchstart', function () {
				$msnryGrid.masonry('layout');
			});
		});
	}


	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if($body.is('.hasSubpageBanner')) {
		site.subpagebanner.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$('.share').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
